export default [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '路径名称',
    field: 'pathName'
  },
  {
    headerName: '学员账号',
    field: 'account',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '学员姓名',
    field: 'fullName'
  },
  /* {
    headerName: '学员身份证',
    field: 'idCard'
  }, */
  {
    headerName: '账号状态',
    field: 'accountState'
  },
  {
    headerName: '学员任职信息',
    field: 'userIdentityInfos'
  },
  {
    headerName: '组织名称',
    field: 'orgName'
  },
  {
    headerName: '组织编码',
    field: 'orgCode'
  },
  {
    headerName: '组织类型名称',
    field: 'nodeCategoryName'
  },
  {
    headerName: '上级组织',
    field: 'leadName'
  },

]
